export class User {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public nombre: string | undefined;
    public apellidos: string | undefined;
    public displayName: string | undefined;
    public userName: string | undefined;
    public avatar: string = '';
    public avatarColor: string | undefined;
}